"use client";

import styled from "styled-components";

interface TitleStrongProps {
  onClick?: React.MouseEventHandler<HTMLHeadingElement>;
  size?: "xs" | "sm" | "md";
}

export const TitleStrong = styled.h4<TitleStrongProps>`
  font-family: "Inter Medium";
  font-size: ${({ size }) =>
    size === "xs" ? "12px" : size === "sm" ? "14px" : "16px"};
  color: var(--textLight);
  transition: 03s ease-out;
  cursor: ${({ onClick }) => (onClick ? "pointer" : "default")};

  &:hover {
    color: var(--colorTitle);
    text-decoration: ${({ onClick }) => (onClick ? "underline" : "none")};
  }
`;
